import {Component, OnInit, AfterViewInit} from '@angular/core';
import {DialogService} from 'src/app/services/dialog.service';
import {redirectToLink} from '../../common/constants';
import {SessionService} from '../../../services/session.service';
import {Router} from '@angular/router';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class MainComponent implements AfterViewInit, OnInit {
    isIEOrEdge: boolean;
    inSessionFlag: boolean;
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;

    constructor(
        private dialogService: DialogService,
        private sessionService: SessionService,
        private router: Router,
        private deviceService: DeviceDetectorService
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        window.scrollTo(0, 0);
        this.isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    }

    ngOnInit(): void {
        this.addDataLayer();
    }

    addDataLayer(): any {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});
        // @ts-ignore
        dataLayer.push({
            event: 'impressionView',
            ecommerce: {
                currencyCode: 'MXN',
                impressions: [
                    {
                        name: 'FAD® Firma - Plan personal - Suscripción Mensual',
                        id: 'FADPPSM',
                        price: '199',
                        brand: 'FAD®',
                        category: 'FAD® Personal',
                        variant: 'Suscripcion Ilimitada',
                        list: 'FAD® Firma - Planes',
                        position: 1
                    },
                    {
                        name: 'FAD® Firma - Plan empresas - Suscripcion Mensual',
                        id: 'FADPESM',
                        price: '499',
                        brand: 'FAD®',
                        category: 'FAD® Empresas',
                        variant: 'Suscripcion Ilimitada',
                        list: 'FAD® Firma - Planes',
                        position: 2
                    }
                ]
            }
        });
    }

    addDataLayerClicProducto(opc: number): any {
        // @ts-ignore
        window.dataLayer = window.dataLayer || [];
        // @ts-ignore
        dataLayer.push({ecommerce: null});  // Clear the previous ecommerce object.

        switch (opc) {
            case 1:
                // @ts-ignore
                dataLayer.push({
                    event: 'productClick',
                    ecommerce: {
                        click: {
                            actionField: {
                                list: 'FAD® Firma - Planes Personal'
                            },
                            products: [{
                                name: 'FAD® Firma - Plan personal - Suscripción Mensual',
                                id: 'FADPPSM',
                                price: '199',
                                brand: 'FAD®',
                                category: 'FAD® Personal',
                                variant: 'Suscripcion Ilimitada',
                                position: 1
                            }]
                        }
                    }
                });
                this.router.navigate(['/firma-digital-para-personas']);
                break;
            case 2:
                // @ts-ignore
                dataLayer.push({
                    event: 'productClick',
                    ecommerce: {
                        click: {
                            actionField: {
                                list: 'FAD® Firma - Planes Empresa'
                            },
                            products: [{
                                name: 'FAD® Firma - Plan empresas - Suscripcion Mensual',
                                id: 'FADPESM',
                                price: '499',
                                brand: 'FAD®',
                                category: 'FAD® Empresas',
                                variant: 'Suscripcion Ilimitada',
                                position: 2
                            }]
                        }
                    }
                });
                this.router.navigate(['/firma-digital-para-empresas']);
                break;
        }
    }

    ngAfterViewInit(): void {
    }

    freeTest(): void {
        this.sessionService.setInitText(true);
        setTimeout(() => {
            if (this.router.url === '/firma-digital-gratis') {
                this.sessionService.emitNewSessionText(true);
            } else {
                this.router.navigate(['/firma-digital-gratis']);
            }
        }, 200);
    }

    moreUseCases(): void {
        redirectToLink('https://blog.firmaautografa.com/los-mil-y-un-usos-de-la-firma-autografa-digital-fad');
    }

    openVideo(): void {
        this.dialogService.showVideoFrame('https://www.youtube.com/embed/ULKgxe3O32g?rel=0&amp;autoplay=1');
    }

    inSession(): boolean {
        const auth = this.sessionService.getAuthData();
        const sess = this.sessionService.getLoginSession();
        return (auth != null && sess != null && auth !== '' && sess !== '' && auth !== 'null' && sess !== 'null');
    }

    login(isLogIn: boolean): void {
        this.inSessionFlag = this.inSession();
        if (this.inSessionFlag) {
            this.dialogService.showConfirmationDialog(
                'Confirmar operación',
                '- ¿  Seguro que quieres cerrar la sesión  ? -',
                () => {
                    sessionStorage.clear();
                    localStorage.clear();
                    this.router.navigate(['/']);
                }
            );
        } else {
            if (isLogIn) {
                if (this.inSessionFlag) {
                    this.sessionService.clearData();
                } else {
                    this.setInitText(false);
                }
            } else {
                this.setInitText(true);
            }
        }
    }

    setInitText(value): void {
        this.sessionService.setInitText(value);
        setTimeout(() => {
            if (this.router.url === '/firma-digital-gratis') {
                this.sessionService.emitNewSessionText(value);
            } else {
                this.router.navigate(['/firma-digital-gratis']);
            }
        }, 200);
    }
}
